import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonCheckbox } from '@ionic/react';

import '../../../css/layout.css';
import { GetGuestSearchMatch } from './GetGuestSearchMatch';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { SelectRoom } from './SelectRoom';

export function Reservation_EnterBookingInfo (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(null);
    let [endDate, setEndDate] = useState(null);
    let [numOfNights, setNumOfNights] = useState(authenticatedMerchent_context.numOfNights);
    let [displaySearch, setDisplaySearch] = useState('none');

    let [checkIn_Non_Member_ID_Type, setCheckIn_Non_Member_ID_Type] = useState('drivers_license')
    let [checkInMemberPaymentType, setCheckInMemberPaymentType ] = useState('cash');
    let [checkInNonMemberPaymentType, setCheckInNonMemberPaymentType ] = useState('cash');
    let [checkInCustomerStatus, setCheckInCustomerStatus ] = useState('non_member');
    //let [checkInAttachment, setCheckInAttachment ] = useState(null);
    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(null);

    const [mobileNumber, setMobileNumber] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    
    let [ccInfoDisplay, setCCInfoDisplay ] = useState('none');
    let [mmInfoDisplay, setMMInfoDisplay ] = useState('none');
    let [checkingInfoDisplay, setCheckingInfoDisplay ] = useState('none');
    let [cashInfoDisplay, setCashInfoDisplay ] = useState('inline-block');

    let [ bookingType, setBookingType ] = useState(null);
    let [checkInRoomID, setCheckInRoomID] = useState('');
    let [checkInRoomID_multiple, setCheckInRoomID_multiple] = useState(null);


    let [originalPrice, setOriginalPrice] = useState(0.00);
    let [roomSalePrice, setRoomSalePrice] = useState(0.00);
    let [bookingPrice, setBookingPrice] = useState(0.00);
    let [roomSalePrice_multiple, setRoomSalePrice_multiple] = useState([]);
    let [bookingPrice_multiple, setBookingPrice_multiple] = useState([]);

    let [discount, setDiscount] = useState(0);


    let [displaySetButton, setDisplaySetButton] = useState('inline-block');
    let [displayResetButton, setDisplayResetButton] = useState('none');

    let [disableBookingButton, setDisableBookingButton] = useState(false);
    let [disableSetButton, setDisableSetButton] = useState(false);
    let [disableResetButton, setDisableResetButton] = useState(false);

    let [taxStatus, setTaxStatus] = useState(true);

    //let selectCheckInDateRef = useRef();
    //let selectCheckOutDateRef = useRef();


    let enterQavaNumberRef = useRef(null);

    let enterMemberPaymentAmountRef = useRef();
    let enterFirstNameRef = useRef();
    let enterLastNameRef = useRef();
    let enterMobileNumberRef = useRef();
    let enterEmailRef = useRef();

    let enterID_numberRef = useRef();
    
    let enterCC_numberRef = useRef();
    let enterCC_expDateRef = useRef();
    let enterCC_cvvNumberRef = useRef();
    let enterCC_addressRef = useRef();
    let enterCC_cityRef= useRef();
    let enterCC_stateRef = useRef();
    let enterCC_zipRef = useRef();
    let enterCC_nonMember_amountRef = useRef();

    let enterMM_displayRef = useRef();
    let selectMobileMoneyProviderRef = useRef();
    let enterMM_phoneNumberRef = useRef();
    let enterMM_nonMember_amountRef = useRef();


    let enterChecking_displayRef = useRef();
    let enterChecking_bankNameRef = useRef();
    let enterChecking_accountNumberRef = useRef();
    let enterChecking_routingNumberRef = useRef();
    let enterChecking_nonMember_amountRef = useRef();

    let enterCash_displayRef = useRef();
    let enterCash_amountRef = useRef();
    let enterDiscountRef = useRef(0);
    let enterIncreaseRef = useRef(0);

    useEffect(() => {

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            //alert('After Response');
            //alert(data);

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setCheckInAttachment_ID(noImageFile);

        })

    }, [])

    function handleEnterAttachement() {  

        let noImageFile = new File([''], '/var/www/web/Public/fileServer/merchants/image-not-available.jpg', {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
          });
        
        setCheckInAttachment_ID(noImageFile);

        alert("No Attachment Option checked");
    }


    function handleSelectIDType(e) {

        let event = [e[0], e[1].target.value];

        if(event[0] == 'member')
        {
            setCheckIn_Non_Member_ID_Type(event[1]);

        }
    }

    function handleSelectPaymentType(e) { 
        e[1].persist(); 
        //alert('In HandleSelectPaymentType');
        //alert(e);

        let event = [e[0], e[1].target.value];

        if(event[0] == 'member')
        {
            setCheckInCustomerStatus(event[0]);  

            if(event[1] == 'member')
            {
                setCheckInMemberPaymentType('none');   
            }
            else if(event[1] == 'cc' || event[1] == 'mm' || event[1] == 'cash' || event[1] == 'checking' )
            {
                setCheckInMemberPaymentType(event[1]);   

            }
        }

        else if(event[0] == 'non_member')
        {
            setCheckInCustomerStatus(event[0]);  

            
            if(event[1] == 'non_member')
            {
                setCheckInNonMemberPaymentType('none');   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'cc')
            {

                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('inline-block');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            } 
            else if(event[1] == 'mm')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('inline-block');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('none');   
            }
            else if(event[1] == 'checking')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('inline-block');   
                setCashInfoDisplay('none');   

            }
            else if(event[1] == 'cash')
            {
                setCheckInNonMemberPaymentType(event[1]);   
                setCCInfoDisplay('none');   
                setMMInfoDisplay('none');   
                setCheckingInfoDisplay('none');   
                setCashInfoDisplay('inline-block');   
            } 
        } 

      
    }



function displaySearchMatchHandler() {
    setDisplaySearch('inline-block');
}

function confirmGuestBooking(e)
{
    e.preventDefault();

    //alert("In confirmGuestBooking");
    setDisableBookingButton(true);

    let formData = new FormData();
    formData.append('user', acctID);
    formData.append('sessionID', sessionID);
    formData.append('xImageFile', checkInAttachment_ID);


    let _Tracker = '';
    let _checkInRoomID = '';
    let _checkInRoomID_multiple = '';
    let _bookingID = '';
    let _checkInDateBooked = '';
    let _checkOutDateBooked = '';
    let _checkInNonMemberPaymentAmount_multiple = '';
    let _checkInNonMemberPaymentAmount = '';


    if(checkInCustomerStatus == 'member')
    {
        formData.append('Tracker', 74705);
        formData.append('user', acctID);
        if(props.tracker == 74701)
        {
            if(checkInRoomID_multiple != null)
            {
                formData.append('xCheckInRoomID_multiple', checkInRoomID_multiple);
            }
            else
            {
                formData.append('xCheckInRoomID', checkInRoomID);
            }
        }
        else
        {
            formData.append('xCheckInRoomID', props.data.roomID);
        }        
        //formData.append('xCheckInSalesPrice', this.state.checkInSalesPrice);
        formData.append('xSearchGuestData', enterQavaNumberRef.current.value);
        formData.append('xCheckInMemberPaymentType', null);
        formData.append('xCheckInMemberPaymentAmount', enterMemberPaymentAmountRef.current.value);
        formData.append('xCheckInDateBooked', startDate);
        formData.append('xCheckOutDateBooked', endDate);
        //formData.append('xCheckInDateBooked', selectCheckInDateRef.current.value);
        //formData.append('xCheckOutDateBooked', selectCheckOutDateRef.current.value);
        formData.append('xCheckInNumberOfNights', numOfNights);
        formData.append('xBookingType', bookingType);


    }
    else if(checkInCustomerStatus == 'non_member')
    {
        //formData.append('Tracker', 74706);
        //formData.append('user', acctID);
        if(props.tracker == 74701)
        {
            if(checkInRoomID_multiple != null)
            {
                /*
                formData.append('Tracker', '74706_multiple');
                formData.append('user', acctID);
                formData.append('xCheckInRoomID_multiple', checkInRoomID_multiple);
                */


                _Tracker = '74706_multiple';
                _checkInRoomID_multiple = checkInRoomID_multiple;
            }
            else
            {
                /*
                formData.append('Tracker', 74706);
                formData.append('user', acctID);
                formData.append('xCheckInRoomID', checkInRoomID);
                */

                _Tracker = '74706';
                _checkInRoomID = checkInRoomID;
            }
        }
        else
        {
            /*
            formData.append('Tracker', 74706);
            formData.append('user', acctID);
            formData.append('xCheckInRoomID', props.data.roomID);
            */

            _Tracker = '74706';
            _checkInRoomID =  props.data.roomID;
        }  
        /*
        //formData.append('xCheckInSalesPrice', this.state.checkInSalesPrice);
        formData.append('xCheckInFirstName', enterFirstNameRef.current.value.replace(/\s+/g, '_'));
        formData.append('xCheckInLastName', enterLastNameRef.current.value.replace(/\s+/g, '_'));
        formData.append('xCheckInMobileNumber', enterMobileNumberRef.current.value.replace(/\s+/g, ''));
        formData.append('xCheckInEmail', enterEmailRef.current.value.replace(/\s+/g, ''));
        formData.append('xCheckInNonMemberIDType', checkIn_Non_Member_ID_Type);
        formData.append('xCheckInNonMemberIDNumber', enterID_numberRef.current.value);
        formData.append('xImageFile', checkInAttachment_ID);

        //formData.append('xCheckInAttachment', enterFirstNameRef.current.value);
        formData.append('xCheckInNonMemberPaymentType', checkInNonMemberPaymentType);
        formData.append('xCheckInDateBooked', startDate);
        formData.append('xCheckOutDateBooked', endDate);
        //formData.append('xCheckInDateBooked', selectCheckInDateRef.current.value);
        //formData.append('xCheckOutDateBooked', selectCheckOutDateRef.current.value);
        formData.append('xCheckInNumberOfNights', numOfNights);
        formData.append('xBookingType', bookingType);
        */

            if(checkInNonMemberPaymentType == 'none')
            {
                if(props.tracker == 74701)
                {
                    if(checkInRoomID_multiple != null)
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', roomSalePrice_multiple);
                        */
                        _checkInNonMemberPaymentAmount = roomSalePrice_multiple;

                    }
                    else
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', parseFloat(bookingPrice).toFixed(2));
                        */

                        _checkInNonMemberPaymentAmount = parseFloat(bookingPrice).toFixed(2);
                    }
                }
                else
                {
                    /*
                    formData.append('xCheckInNonMemberPaymentAmount', props.data.roomSalePrice);
                    */

                    _checkInNonMemberPaymentAmount = props.data.roomSalePrice;

                }
            } 
            /*
            else if(checkInNonMemberPaymentType == 'cc')
            {
                formData.append('xCheckInCreditCardNumber', enterCC_numberRef.current.value);
                formData.append('xCheckInCreditCardExpDate', enterCC_expDateRef.current.value);
                formData.append('xCheckInCreditCardCvvNumber', enterCC_cvvNumberRef.current.value);
                formData.append('xCheckInCreditCardAddress', enterCC_addressRef.current.value);
                formData.append('xCheckInCreditCardCity', enterCC_cityRef.current.value);
                formData.append('xCheckInCreditCardState', enterCC_stateRef.current.value);
                formData.append('xCheckInCreditCardZipCode', enterCC_zipRef.current.value);
                formData.append('xCheckInNonMemberPaymentAmount', enterCC_nonMember_amountRef.current.value);
      
            } 
            else if(checkInNonMemberPaymentType == 'mm')
            {
                formData.append('xCheckInMobileMoneyProvider', selectMobileMoneyProviderRef.current.value);
                formData.append('xCheckInMobileMoneyPhoneNumber', enterMM_phoneNumberRef.current.value);
                formData.append('xCheckInNonMemberPaymentAmount', enterMM_nonMember_amountRef.current.value);
            }
            else if(checkInNonMemberPaymentType == 'checking')
            {
                formData.append('xCheckInBankName', enterChecking_bankNameRef.current.value);
                formData.append('xCheckInAccountNumber', enterChecking_accountNumberRef.current.value);
                formData.append('xCheckInRoutingNumber', enterChecking_routingNumberRef.current.value);
                formData.append('xCheckInNonMemberPaymentAmount', enterChecking_nonMember_amountRef.current.value);
            }
            */
            else if(checkInNonMemberPaymentType == 'cash')
            {
                if(props.tracker == 74701)
                {
                    if(checkInRoomID_multiple != null)
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', roomSalePrice_multiple);
                        */

                        _checkInNonMemberPaymentAmount = roomSalePrice_multiple;
                    }
                    else
                    {
                        /*
                        formData.append('xCheckInNonMemberPaymentAmount', parseFloat(bookingPrice).toFixed(2));
                        */

                        _checkInNonMemberPaymentAmount = parseFloat(bookingPrice).toFixed(2);

                    }
                }
                else
                {
                    /*
                    formData.append('xCheckInNonMemberPaymentAmount', props.data.roomSalePrice);
                    */

                    _checkInNonMemberPaymentAmount = props.data.roomSalePrice;

                }
            }

    }


    /*
    const requestOptions = {
        encType: 'multipart/form-data',
        method:'POST',
        credentials: 'include',
        files: formData,
        body: formData,
        contentType: false,
        processData: false,
    }
    */

    const requestOptions0 = {
        encType: 'multipart/form-data',
        method:'POST',
        //credentials: 'include',
        /*headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },*/
        //files: formData,
        body: formData,
        /*body: JSON.stringify({
            user: acctID,
            sessionID: sessionID,
        }),*/
        //contentType: false,
        //processData: false,
    }

    fetch(baseURL+'upload', requestOptions0)
    .then(res => res.text())
    .then(res => {

        //alert('In upload response');

        //setUploadedFile(res.toString());

        //alert(res.toString());

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: _Tracker,
                user: acctID,
                //xCheckInSalesPrice: checkInSalesPrice,
                xCheckInFirstName: enterFirstNameRef.current.value.replace(/\s+/g, '_'),
                xCheckInLastName: enterLastNameRef.current.value.replace(/\s+/g, '_'),
                xCheckInMobileNumber: mobileNumber.replace(/\s+/g, ''),
                xCheckInEmail: enterEmailRef.current.value.replace(/\s+/g, ''),
                xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                //xCheckInAttachment_ID: checkInAttachment_ID,
                //xImageFile: checkInAttachment_ID,
                //xCheckInAttachment: checkInAttachment,
                xCheckInCreditCardNumber: enterCC_numberRef.current.value,
                xCheckInCreditCardExpDate: enterCC_expDateRef.current.value,
                xCheckInCreditCardCvvNumber: enterCC_cvvNumberRef.current.value,
                xCheckInCreditCardAddress: enterCC_addressRef.current.value,
                xCheckInCreditCardCity: enterCC_cityRef.current.value,
                xCheckInCreditCardState: enterCC_stateRef.current.value,
                xCheckInCreditCardZipCode: enterCC_zipRef.current.value,
                xCheckInMobileMoneyProvider: selectMobileMoneyProviderRef.current.value,
                xCheckInMobileMoneyPhoneNumber: enterMM_phoneNumberRef.current.value,
                xCheckInBankName: enterChecking_bankNameRef.current.value,
                xCheckInAccountNumber: enterChecking_accountNumberRef.current.value,
                xCheckInRoutingNumber: enterChecking_routingNumberRef.current.value,

                xCheckInNonMemberPaymentType: checkInNonMemberPaymentType,
                xCheckInRoomID: _checkInRoomID,
                xCheckInRoomID_multiple: _checkInRoomID_multiple,
                xCheckInDateBooked: startDate,
                xCheckOutDateBooked: endDate,
                xCheckInNumberOfNights: numOfNights,
                xBookingType: bookingType,
                xCheckInNonMemberPaymentAmount: _checkInNonMemberPaymentAmount,
                xCheckInNonMemberPaymentAmount_multiple: _checkInNonMemberPaymentAmount_multiple,
                sessionID: sessionID,
                xCheckInAttachment: res.toString(),
                xTaxStatus: taxStatus,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
    
            let rows = res.toString().split('~~~');
    
            alert(res);
    
            props.closeModal();
    
        })

    })
    

}

function onCheckInDateHandler(event) {

    //alert('In onCheckInDateHandler');
    //alert(event);
    //alert(event.startDate);

    //selectCheckInDateRef = event.startDate;
    //selectCheckOutDateRef = event.endDate;
    setStartDate(event.startDate);
    setEndDate(event.endDate);
    setNumOfNights(event.numOfNights);

}
function onCheckInRoomIDHandler(event) {

    //alert('In EnterBookingInfo');
    //alert(event);
    //alert(event.selectedRoomID);
    //alert(event.selectedBookingType);
    //alert(event.selectedRoomSalesPrice);

    //props.onCheckInRoomID(event);
    setBookingType(event.selectedBookingType);
    setCheckInRoomID(event.selectedRoomID);
        setCheckInRoomID_multiple(null);
    setRoomSalePrice(event.selectedRoomSalesPrice);
    setBookingPrice(event.selectedRoomSalesPrice);
    setOriginalPrice(event.selectedRoomSalesPrice);

}

function onCheckInRoomID_multipleHandler(event) 
{


    //alert('In onCheckInRoomID_multipleHandler');
    //alert(event.selectedRoomSalesPrice.length - 1);

    setBookingType(event.selectedBookingType);
    setCheckInRoomID_multiple(event.selectedRoomID);
    setRoomSalePrice_multiple(event.selectedRoomSalesPrice);
    setBookingPrice_multiple(event.selectedRoomSalesPrice);

    let totalBookingPrice = 0.00;
    for(let col = 0; col < event.selectedRoomSalesPrice.length - 1; ++col)
    {
        //alert(totalBookingPrice);

        totalBookingPrice = parseFloat(Number(totalBookingPrice) + Number(event.selectedRoomSalesPrice[col])).toFixed(2);

    }

    setRoomSalePrice(totalBookingPrice);
    setBookingPrice(totalBookingPrice);
    setOriginalPrice(totalBookingPrice);

}

/*function setDiscountHandler()
{
    if(enterIncreaseRef.current.value > 0)
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        setDisplayResetButton('inline-block');
        setBookingPrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
        setDisableResetButton(false);  
    }
    else
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        setDisplayResetButton('inline-block');
        setBookingPrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton(false);
    }
}*/
function setDiscountHandler()
{
    if(enterIncreaseRef.current.value > 0)
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        setDisplayResetButton('inline-block');
        setRoomSalePrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
        setBookingPrice(roomSalePrice + (roomSalePrice*(enterIncreaseRef.current.value/100)));
        setDisableResetButton(false);

        if(checkInRoomID_multiple != null)
        {
            let newRoomSalesPrice_Multiple = [];

            for(let i = 0; i < roomSalePrice_multiple.length; ++i)
            {
                newRoomSalesPrice_Multiple.push(roomSalePrice_multiple[i] + (roomSalePrice_multiple[i]*(enterIncreaseRef.current.value/100)));
            }
            
            setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
        }
    }
    else
    {
        setDisableSetButton(true);
        setDisplaySetButton('none');
        setDisplayResetButton('inline-block');
        setRoomSalePrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setBookingPrice(roomSalePrice - (roomSalePrice*(enterDiscountRef.current.value/100)));
        setDisableResetButton(false);

        if(checkInRoomID_multiple != null)
        {
            let newRoomSalesPrice_Multiple = [];

            for(let i = 0; i < roomSalePrice_multiple.length; ++i)
            {
                newRoomSalesPrice_Multiple.push(roomSalePrice_multiple[i] - (roomSalePrice_multiple[i]*(enterDiscountRef.current.value/100)));
            }
            
            setRoomSalePrice_multiple(newRoomSalesPrice_Multiple);
        }
    }
}

function resetDiscountHandler()
{
    setDisableResetButton(true);
    setDisplaySetButton('inline-block');
    setDisplayResetButton('none');
    setRoomSalePrice(originalPrice);
    setBookingPrice(originalPrice);

    if(checkInRoomID_multiple != null)
    {
        setRoomSalePrice_multiple(originalPrice);
    }
    enterDiscountRef.current.value = '';
    enterIncreaseRef.current.value = '';
    setDisableSetButton(false);
}

function handleMobileNumberChange(e) {

    const IonInput = e.detail.value || '';
    if (!IonInput.startsWith('0')) {
        setErrorMessage('Mobile number must start with 0.');
    } else {
        setErrorMessage('');
    }
    setMobileNumber(IonInput);
};

return (
    <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal isOpen={ props.openModal }>
            <form onSubmit={confirmGuestBooking}>
            <IonHeader style={{ color: "black" }}>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h4>BOOK GUEST</h4>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
            <IonContent className='grid_content'>
                <IonGrid >
                
                    <SelectRoom openModal={ props.openModal } onCheckInRoomID= { onCheckInRoomIDHandler} onCheckInRoomID_multiple={onCheckInRoomID_multipleHandler} onCheckInDate={onCheckInDateHandler} selectRoomTracker={'74701B'} tracker={74701} ></SelectRoom>
                    {/*<IonRow>
                        <IonCol> Qava Member </IonCol>
                        <IonCol> Non-Member </IonCol>
                    </IonRow>*/} 
            {/*<IonSlide>
                <IonGrid>
                    <IonRow>
                        <IonCol>qava Number:</IonCol>
                        <IonCol>
                            <IonInput placeholder='Search Member by Phone' ref={enterQavaNumberRef }></IonInput>
                        </IonCol>
                        <IonCol>
                            <IonButton  onClick={displaySearchMatchHandler}> Search </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            {
                                enterQavaNumberRef.current != null ?
                                (
                                    <IonCard style={{display: displaySearch}}>
                                        <GetGuestSearchMatch tracker={74107} searchGuestData={enterQavaNumberRef.current.value}></GetGuestSearchMatch>
                                    </IonCard>
                                ) : null
                            }
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonLabel htmlFor="QavaPaymentType">Payment Type </IonLabel>
                            <select name="QavaPaymentType" id='QavaPaymentType' onChange={(e) => handleSelectPaymentType(['member', e]) }>
                                <option value='member'>Select</option>
                                <option value='cc'>Credit Card</option>
                                <option value='mm'>Mobile Money</option>
                                <option value='checking'>Checking</option>
                                <option value='cash' selected='selected'>Cash</option>
                            </select>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonLabel>Amount: </IonLabel>
                                <IonInput placeholder='Enter Payment Amount' ref={enterMemberPaymentAmountRef }></IonInput>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonSlide>*/}    
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel>First Name: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterFirstNameRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel>Last Name: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterLastNameRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="6">
                            <label htmlFor="mobileNumber">Mobile Number:</label>
                        </IonCol>
                        <IonCol size="6">
                            <IonInput
                                className='professional-input'
                                id="mobileNumber"
                                placeholder="Enter mobile number"
                                type="tel"
                                value={mobileNumber}
                                maxlength={10}
                                onIonChange={(e) => handleMobileNumberChange(e)}
                                required/>
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel>Email: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterEmailRef}></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel htmlFor="paymenttype">ID Type </IonLabel>                                    
                        </IonCol>
                        <IonCol size='6'>
                            <select name="paymenttype" id='paymenttype' onChange={(e) => handleSelectIDType(['non_member', e]) }>
                                <option value='ghana_id'>GhanaID</option>
                                <option value='drivers_license' selected='selected'>Drivers License</option>
                                <option value='passport'>Passport</option>
                            </select>
                        </IonCol>
                    </IonRow>
                    <IonRow>  
                        <IonCol size='6'>                                              
                            <IonLabel>ID Number: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterID_numberRef }></IonInput>
                        </IonCol> 
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <form id='fileUpload' encType='multipart/form-data'>
                                <label htmlFor='checkInAttachment_ID'>ID Photo</label>
                                    <input id='checkInAttachment_ID' type='file' name='imageFile' accept="image/*" onChange={(e) => setCheckInAttachment_ID(e.target.files[0])}></input>
                                <label htmlFor='noAttachment_ID'>Customer Denied Photo</label>
                                    <input type='checkbox' id='noAttachment_ID' value='noImage' onClick={() => handleEnterAttachement()}></input>
                            </form>                                        
                        </IonCol>
                    </IonRow>
                    {/*<IonRow>
                        <IonCol>
                            <form id='fileUpload' encType='multipart/form-data'>
                                <label htmlFor='checkInAttachment'>Attachment</label>
                                    <input id='checkInAttachment' type='file' name='imageFile' accept="image/*" onChange={(e) => handleEnterAttachement(e)}></input>
                                <label htmlFor='noAttachment'>No Attachment</label>
                                    <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => handleEnterAttachement(e)}></input>
                            </form>                                        
                        </IonCol>
                    </IonRow>*/}
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel htmlFor="paymenttype">Payment Type </IonLabel>                                    
                        </IonCol>
                        <IonCol size='6'>
                            <select name="paymenttype" id='paymenttype' onChange={(e) => handleSelectPaymentType(['non_member', e]) }>
                                {authenticatedMerchent_context.accessRights[0] == 'admin' && <option value='cc'>Credit Card</option>}
                                {authenticatedMerchent_context.accessRights[0] == 'admin' && <option value='mm'>Mobile Money</option>}
                                {authenticatedMerchent_context.accessRights[0] == 'admin' && <option value='checking'>Checking</option>}
                                <option value='cash' selected='selected'>Cash</option>
                            </select>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: ccInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel>Credit Card Number: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterCC_numberRef }></IonInput>
                        </IonCol>
                    </IonRow >
                    <IonRow style={{display: ccInfoDisplay}}>  
                        <IonCol size='6'>                                              
                            <IonLabel>Exp Date: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterCC_expDateRef }></IonInput>
                        </IonCol> 
                    </IonRow>
                    <IonRow style={{display: ccInfoDisplay}}>    
                        <IonCol size='6'>
                            <IonLabel>Cvv: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterCC_cvvNumberRef }></IonInput>
                        </IonCol> 
                    </IonRow>
                    <IonRow style={{display: ccInfoDisplay}}>    
                        <IonCol size='6'>
                            <IonLabel>Address: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterCC_addressRef }></IonInput>
                        </IonCol> 
                    </IonRow>
                    <IonRow style={{display: ccInfoDisplay}}> 
                        <IonCol size='6'>   
                            <IonLabel>City: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterCC_cityRef }></IonInput>
                        </IonCol> 
                    </IonRow>
                    <IonRow style={{display: ccInfoDisplay}}>    
                        <IonCol size='6'>
                            <IonLabel>state: </IonLabel>
                        </IonCol>
                        <IonCol>
                            <IonInput placeholder='Enter' ref={enterCC_stateRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: ccInfoDisplay}}>     
                        <IonCol size='6'>
                            <IonLabel>Zip Code: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={ enterCC_zipRef}></IonInput>
                        </IonCol> 
                    </IonRow>
                    <IonRow style={{display: ccInfoDisplay}}> 
                        <IonCol size='6'>   
                            <IonLabel>Amount: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterCC_nonMember_amountRef }></IonInput>
                        </IonCol>    
                    </IonRow>
                    <IonRow style={{display: mmInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel htmlFor="mmProvider">Mobile Money Provider: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <select name="mmProvider" id='mmProvider' ref={selectMobileMoneyProviderRef}>
                                <option value='none'>Select</option>
                                <option value='mtn'>mtn</option>
                                <option value='vodafone'>vodafone</option>
                                <option value='private'>Private</option>
                            </select>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: mmInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel>Mobile Phone Number: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={ enterMM_phoneNumberRef  }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: mmInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel>Amount: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={ enterMM_nonMember_amountRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: checkingInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel htmlFor="checkingProvider">Bank Name: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterChecking_bankNameRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: checkingInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel>Checking Account Number: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterChecking_accountNumberRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: checkingInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel>Routing Number: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={enterChecking_routingNumberRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    <IonRow style={{display: checkingInfoDisplay}}>
                        <IonCol size='6'>                        
                            <IonLabel>Amount: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            <IonInput placeholder='Enter' ref={ enterChecking_nonMember_amountRef }></IonInput>
                        </IonCol>
                    </IonRow>
                    {/*<IonRow style={{display: cashInfoDisplay}}>*/}
                    <IonRow>
                        <IonCol size='4'>
                            <h4>Discount: </h4>
                        </IonCol>
                        <IonCol size='2'>
                            <IonInput style={{display: displaySetButton}} type='number' placeholder='Dn %' ref={enterDiscountRef}></IonInput>
                            <h4 style={{display: displayResetButton}}>{enterDiscountRef.current.value+' %'}</h4>
                        </IonCol>
                        <IonCol size='2'>
                            <IonInput style={{display: displaySetButton}} type='number' placeholder='Up %' ref={enterIncreaseRef}></IonInput>
                            <h4 style={{display: displayResetButton}}>{enterIncreaseRef.current.value+' %'}</h4>
                        </IonCol>
                        <IonCol size='4'> 
                            <IonButton style={{display: displaySetButton}} disabled={disableSetButton} onClick={() => setDiscountHandler()}>Set</IonButton>
                            <IonButton style={{display: displayResetButton}} disabled={disableResetButton} onClick={() => resetDiscountHandler()}>Reset</IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h4>Room Price Per Night: </h4>
                            <h4>Total: </h4>
                        </IonCol>
                        <IonCol size='6'>
                            <h4>{parseFloat(bookingPrice).toFixed(2)}</h4>
                            <h4>{parseFloat(bookingPrice * numOfNights).toFixed(2)}</h4>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                    <IonCol>
                        <IonText>NO TAX</IonText>
                    </IonCol>
                    <IonCol>
                        <IonCheckbox checked={taxStatus} onIonChange={() => setTaxStatus(!taxStatus)}> NO TAX </IonCheckbox>                         
                    </IonCol>
                </IonRow>
                </IonGrid>
            </IonContent>
            <IonFooter className='grid_footer'>
                <IonGrid >
                    <IonRow>
                        <IonCol>
                            <IonButton type='submit' disabled={disableBookingButton}> Confirm Booking </IonButton>
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() => props.closeModal()}> Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
            </form>
            </IonModal>
            ) : null}
    </React.Fragment>)
}